import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '../../css/NewsTicker.css'
import Utils from "../../utils/Utils";

function DatasetsNewsTicker() {
    const [datasets, setDatasets] = useState([]);

    useEffect(() => {
        const loadDatasets = async () => {
            try {
                const res = await Utils.getAllDirs();
                const response = res.data.items || [];

                const dirs = response
                    .filter((item) => item.name && item.path)
                    .map((item) => ({
                        name: item.name,
                        path: item.path,
                    }));
                setDatasets(dirs);
            } catch (err) {
                console.error("Failed to load header datasets:", err);
            }
        };

        loadDatasets();
        }, []);

    if (!datasets.length) return null;

    return (
        <div style={{marginBottom: "25px"}}>
          <h3>Available datasets:</h3>
          <br/>
          <div className="news-ticker">
              <ul>
                  {datasets.map(item => {
                      console.log(item);
                          return (<li key={item.id}>
                              <Link to={`/data/${item.path}`}>{item.name}</Link>
                              </li>)
                      }
                  )}
              </ul>
          </div>
      </div>
    );
}

export default DatasetsNewsTicker;